export default function loadData(key) {
  // eslint-disable-next-line no-underscore-dangle
  return window.__bootstrap && window.__bootstrap[key];
}
